import { AxiosError } from 'axios';
import instance from '../config/axios';
import { CreateSubstituteTokenProps } from '../interface/interface';

export const createSubstituteToken = async (
  props: CreateSubstituteTokenProps,
  accessToken: string,
) => {
  try {
    const response = await instance({
      method: 'PUT',
      url: '/api/v1/order/substitute_token',
      data: { ...props },
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response?.data;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response?.status;
  }
};
